import { useCallback, useMemo } from "react"
import { generateValidateOnCoverDate, generateValidateOffCoverDate, generateValidateVRN } from "."
import { BaseFleetEntry, FleetEntry } from "../../api/fleet"
import { PolicyDuration } from "../types"

export const useFleetEntryValidation = (
  entries: ReadonlyArray<FleetEntry>,
  policyDuration: PolicyDuration,
  hasAdminAccess: boolean,
  isHavenPolicy: boolean,
  isCourier: boolean,
  otherProps?: {
    isEdit?: boolean
    onCoverDateRequired?: boolean
  }
) => {
  const generatorProps = useMemo(
    () => ({
      curentEntries: entries,
      policyDuration,
      hasAdminAccess,
      isHavenPolicy,
      isCourier,
    }),
    [entries, policyDuration, hasAdminAccess, isHavenPolicy, isCourier]
  )
  const validateOnCoverDate = useMemo(
    () =>
      generateValidateOnCoverDate(generatorProps, {
        isEdit: otherProps?.isEdit,
        isRequired: otherProps?.onCoverDateRequired,
      }),
    [generatorProps, otherProps]
  )
  const validateOffCoverDate = useMemo(() => generateValidateOffCoverDate(generatorProps), [generatorProps])
  const validateVRN = useMemo(() => generateValidateVRN(generatorProps), [generatorProps])

  const validateRows = useCallback(
    (rows: ReadonlyArray<Partial<BaseFleetEntry>>) =>
      rows.map((row) => ({
        registrationNumber: validateVRN(row),
        onCoverDate: validateOnCoverDate(row),
        offCoverDate: validateOffCoverDate(row),
      })),
    [validateOnCoverDate, validateOffCoverDate, validateVRN]
  )
  return { validateOnCoverDate, validateOffCoverDate, validateVRN, validateRows }
}
